import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    title: 'Customer portal',
    logoSRC: '',
    logoSize: {
      width: 200,
      height: 45,
    },
    uploadMaxFileSize: '10',
    navbarLinks: [],
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_TITLE(state, val) {
      state.title = val
    },
    UPDATE_LOGO_SRC(state, val) {
      state.logoSRC = val
    },
    UPDATE_LOGO_SIZE(state, val) {
      state.logoSize = val
    },
    UPDATE_UPLOAD_MAX_FILE_SIZE(state, val) {
      state.uploadMaxFileSize = val
    },
    UPDATE_NAVBAR_LINKS(state, val) {
      state.navbarLinks = val
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
  },
  actions: {},
}
